import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ViewContentWrapper, BreadcrumbWrapper } from './PTPlusStyled'
import BasicInfo from './ViewAndEditSections/BasicInfo';
import TaxId from './ViewAndEditSections/TaxId';
import BillTo from './ViewAndEditSections/BillTo';
import FeeType from './ViewAndEditSections/FeeType';
import FlatFee from './ViewAndEditSections/FlatFee';
import PaymentMethod from './ViewAndEditSections/PaymentMethod';
import TaxExemption from './ViewAndEditSections/TaxExemption';
import LocatoinSetUp from './ViewAndEditSections/LocationSetUp';
import Notes from './ViewAndEditSections/Notes';
import { Formik } from 'formik';
import { setInitialValues, VALIDATION_SCHEMA } from './ViewAndEditSections/viewAndEditUtils'
import BuyBackFee from './ViewAndEditSections/BuyBackFee';
import { fetchLocationListApi } from 'redux/actions/adminPtPlus';
import { logoutAdmin, storeAdminDetails } from 'redux/actions/admin';
import AlertModal from 'web/components/AlertModal';

function ViewAndEditUserInfo(pageProps) {
  const dispatch = useDispatch();
  let history = useHistory()
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [locationsList, setLocationsList] = useState([])
  const [flatFeeDataList, setFlatFeeDataList] = useState([])
  const [flatFeeAddModal, setFlatFeeAddModal] = useState(false)

  const [buyBackFeeDataList, setBuyBackFeeDataList] = useState([])

  useEffect(() => {
    pageProps.scrollTop()
    fetchLocationsListFunction()
  }, []);

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const fetchLocationsListFunction = async (type) => {
    let response = ''
    let id = pageProps.draftData.id
    const token = localStorage.getItem('token')
    response = await dispatch(fetchLocationListApi(id, token))
    if (!localStorage.getItem("token")) {
      adminLogout()
    } else {
      if (response.success) {
        let mainlocationsListTemp = []
        let sublocationsListTemp = []
        if (response.data.locations?.length > 0 && response.data.locations[0].mainLocation) {
          mainlocationsListTemp = [response.data.locations[0].mainLocation]
        }
        if (response.data.locations?.length > 0 && response.data.locations[0].subLocations?.length > 0) {
          sublocationsListTemp = response.data.locations[0].subLocations
        }
        let locationsListTemp = [...mainlocationsListTemp, ...sublocationsListTemp]
        setLocationsList(locationsListTemp)

        let flatFeeListTemp = []
        flatFeeListTemp = locationsListTemp.map(location =>
          location.flatFee.map(fee => ({
            ...fee,
            address: location.address
          }))
        )
        setFlatFeeDataList(flatFeeListTemp.flat())

        let buyBackList = []
        buyBackList = mainlocationsListTemp.map(val => val.buyBackDet)
        setBuyBackFeeDataList(buyBackList.flat())
      } else {
        if (response?.statusCode === 401) {
          adminLogout()
        } else {
          setAlertModalContent(response?.data?.error?.message)
          setAlertModal(!alertModal)
        }
      }
      if (type === 'openFlatFeeModal') setFlatFeeAddModal(true)
    }
  }

  return (
    <>
      <BreadcrumbWrapper>
        <p onClick={() => pageProps.setSelectedPage('userLists')}>{`Account Management`}</p>
        <span>{`>`}</span>
        <h6>{`User Info`}</h6>
      </BreadcrumbWrapper>
      <ViewContentWrapper>
        <Formik
          initialValues={setInitialValues(pageProps.draftData)}
          validationSchema={VALIDATION_SCHEMA}
          onSubmit={(values) => { }}>
          {(props) => {
            const { setFieldValue } = props;
            return (
              <>
                <BasicInfo formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <TaxId formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <BillTo formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <FeeType formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <FlatFee
                  formikProps={props}
                  pageData={pageProps.draftData}
                  setFieldValue={setFieldValue}
                  locationsList={locationsList}
                  flatFeeDataList={flatFeeDataList}
                  adminLogout={adminLogout}
                  fetchLocationsListFunction={fetchLocationsListFunction}
                  setFlatFeeAddModal={setFlatFeeAddModal}
                  flatFeeAddModal={flatFeeAddModal}
                />
                <BuyBackFee
                  pageData={pageProps.draftData}
                  buyBackFeeDataList={buyBackFeeDataList}
                />
                <PaymentMethod formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <TaxExemption formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
                <LocatoinSetUp
                  formikProps={props}
                  pageData={pageProps.draftData}
                  refreshUserData={pageProps.refreshUserData}
                  setFieldValue={setFieldValue}
                />
                <Notes formikProps={props} pageData={pageProps.draftData} setFieldValue={setFieldValue} />
              </>
            );
          }}
        </Formik>
      </ViewContentWrapper>
      <ViewContentWrapper>
        <button className='back-button' onClick={() => pageProps.setSelectedPage('userLists')}>Back</button>
      </ViewContentWrapper>
      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        content={alertModalContent}
      />
    </>
  )

}

export default ViewAndEditUserInfo